import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssessmentsService {
  canActivate(): boolean | Observable<boolean> {
    let allowAssessment = localStorage.getItem('allowAssessment');
    return allowAssessment && JSON.parse(allowAssessment);
  }

  closeAssessment() {
    localStorage.setItem('allowAssessment', 'false');
  }

  setAssessmentsRequest(request: any) {
    sessionStorage.setItem('AssessmentsRequest', JSON.stringify(request));
  }

  getAssessmentsRequest() {
    const assessmentsRequest = sessionStorage.getItem('AssessmentsRequest');
    return assessmentsRequest ? JSON.parse(assessmentsRequest) : {};
  }
}
